<script>
    export default {
        data() {
            return {
                selected: this.$parent.selectedMutable,
                selector: this.$parent.selector,
                options: this.$parent.options,
                edit: false,
            }
        },
        methods: {
            updated() {
                this.$emit('update', this.selected);
                this.edit = false;
            }
        }
    }
</script>

<template>
    <div>

        <h5 class="m-b-xs">
            <span>{{ $parent.headline }}</span>
            <a @click="edit = true" v-if="!edit"><i class="fa fa-pencil"/></a>
        </h5>

        <p class="text-muted m-b-md" v-if="!edit">
            <span>{{ selected[selector] }}</span>
        </p>

        <div v-else>
            <div class="row">
                <div class="col-md-10 form-inline">
                    <v-select
                            :label="selector"
                            :options="options"
                            @input="updated"
                            v-model="selected"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
